'use strict';
/**
 * @author Maxim Seredkin
 * @return {*}
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/staff-select.html'),
        transclude: true,
        scope: {
            staff: '=myValue',
            mySize: '=?mySize',
            myFilters: '=?myFilters',
            myRequired: '=?myRequired',
            myDef: '=?myDef',
            myReadonly: '=?myReadonly',
            myDisabled: '=?myDisabled',
            myTooltip: '=?myTooltip',
        },
        controller: ['$scope', 'StaffService', '$sce',
            function($scope, StaffService, $sce) {
                $scope.select = select;
                $scope.clear = clear;
                $scope.tooltipContent = $sce.trustAsHtml(`${$scope.myTooltip}`);

                // region Function

                /**
                 * Выбрать
                 */
                function select() {
                    StaffService.select($scope.staff, $scope.myFilters, $scope.myDef).result.then((data) => $scope.staff = data);
                }

                /**
                 * Очистить
                 */
                function clear() {
                    $scope.staff = null;
                }

                // endregion

                $scope.$watch("myTooltip", function(newValue) {
                    $scope.tooltipContent = $sce.trustAsHtml(`${newValue}`);
                })
            }],
    };
}
